<template>
    <div class="container">
        <div class="kt-portlet">
            <div class="kt-portlet__body">
                <div class="kt-section">
                    <div class="kt-section__content">
                        <div class="table-responsive">
                            <table class="table table-sm">
                                <thead>
                                <tr>
                                    <th>Nº solicitud</th>
                                    <th>Fecha de solicitud</th>
                                    <th>Modelo a financiar</th>
                                    <th class="text-right">Valor entrada</th>
                                    <th class="text-right">Valor a financiar</th>
                                    <th class="text-center">Estado</th>
                                    <th class="text-center">Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="cargando">
                                    <tr>
                                        <td colspan="6" class="text-muted text-center">
                                            <i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i> Cargando
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <template v-for="(i,ii) in lista" >
                                        <tr :key="ii">
                                            <th scope="row">{{i.dt11}}</th>
                                            <td>{{fechaLarga(i.ddt2)}}</td>
                                            <td>
                                                <span>{{i.dt4}}</span>
                                                <small>{{i.dt1}}</small>
                                                <small class="text-muted" v-for="j in i.elements" :key="j.dt1">{{j.dt2}}</small>
                                                <small class="text-muted" v-for="j in i.elements2" :key="j.dt1">{{j.dt2}}</small>
                                            </td>
                                            <td class="text-right precio-syb">{{punto(i.ndt10)}}</td>
                                            <td class="text-right precio-syb">{{punto(i.ndt12)}}</td>
                                            <td class="text-center">
                                                <span class="badge" :class="colorStado(i)">{{i.dt12}}</span>
                                            </td>
                                            <td class="text-center">
                                                <button type="button" v-if="i.bdt3" class="btn btn-primary btn-elevate btn-pill btn-sm" v-on:click="irDetalle(i)">
                                                    Ver detalle
                                                </button>
                                            </td>
                                        </tr>
                                        <tr class="p-0 animated fadeIn" :key="ii+'-a'" v-if="!i.bdt2 && i.bdt5">
                                            <td colspan="7">
                                                <div class="alert alert-light alert-elevate" role="alert">
                                                    <div class="alert-icon text-success"><i class="fa fa-check-circle"></i></div>
                                                    <div class="alert-text">
                                                        Estimado cliente: <br>
                                                        Su solicitud de financiamiento ha sido aprobada exitosamente.
                                                        <div class="row mt-2">
                                                            <div class="col-3">
                                                                <button type="button" class=" p-0 btn btn-primary btn-elevate btn-pill btn-block" :disabled="i.cargandoA || i.cargandoR" :class="i.cargandoA && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light'" v-on:click="cambioEstado(true,i)">
                                                                    Aceptar financiamiento
                                                                </button>
                                                            </div>
                                                            <div class="col-3">
                                                                <button type="button" class=" p-0 btn btn-outline-primary btn-elevate btn-pill btn-block" :disabled="i.cargandoR || i.cargandoA" :class="i.cargandoR && 'kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--brand'" v-on:click="cambioEstado(false,i)">
                                                                    Rechazar financiamiento
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-if="lista.length===0">
                                        <td colspan="7" class="text-muted text-center">
                                            No existen registros
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {negociacion, solicitudCredito} from "../../servicios";
    import constantes from "../../constantes";
    import _ from 'lodash';
    export default {
        name: "credito",
        data:()=>({
            lista:[],
            cargando:true,
        }),
        methods:{
            fechaLarga:(fechaIso)=>constantes.funciones.formatoFechaL(fechaIso),
            punto:(n)=>constantes.funciones.puntoMilesDecimal(n),
            colorStado:(obj)=>constantes.funciones.colorEstado(obj.dt12),
            consultaCredito:function(){
                this.cargando=true;
                negociacion.listaPorTipo(2).then(r=>r.data).then(response=>{
                    response.map(i=>{
                        i.cargandoA=false;
                        i.cargandoR=false;
                    });
                    this.lista=response;
                    this.cargando=false;
                });
            },
            cambioEstado:function(estado,item){
                if(estado)
                    item.cargandoA=true;
                else
                    item.cargandoR=true;
                this.enviarCambioEstado(estado,item);
            },
            enviarCambioEstado:_.debounce(function (estado,item) {
                solicitudCredito.cambioEstado(estado,item).then(()=>{
                    item.cargandoA=false;
                    item.cargandoR=false;
                    if(estado){
                        this.$store.commit('setCotizacion',item);
                        this.$router.push({ name: 'compras.contado' });
                    } else
                        this.consultaCredito();
                }).catch(()=>{
                    item.cargandoA=false;
                    item.cargandoR=false;
                    this.consultaCredito();
                })
            },2000),
            irDetalle:function(i){
                this.$store.commit('setCotizacion',i);
                this.$router.push({ name: 'credito.detalle' });
            }
        },
        mounted() {
            this.consultaCredito();
        }
    }
</script>

<style scoped>
    td small {
        display: block;
    }
</style>
